import React from 'react'

export default function Section7() {
    return (
        <div className='bg-black py-10 text-white relative min-h-[70vh] flex items-center'>
            <div className='bg-[#010010]/70 p-7 md:p-10 rounded-xl border shadow-sm shadow-white w-[80%] mx-auto relative' style={{zIndex: 1}}>
                <p className='text-lg md:text-2xl font-semibold text-center'>Stay Informed with Stabilix</p>
                <p className='text-xs md:text-sm font-semibold text-center text-gray-500'>Be the first to know about platform updates, new features, and industry insights. Join our community to stay connected with everything happening at Stabilix.</p>

                <div className='mt-5 md:mt-10 flex flex-col md:flex-row items-center gap-3'>
                <input className='outline-none py-2 px-3 bg-transparent w-[100%] md:w-[80%] border rounded-md'></input>
                <button className='w-[100%] md:w-[20%] bg-white text-black py-2 rounded-xl font-semibold duration-300 active:translate-y-1 text-xs'>Subscribe to Our Updates</button>
                </div>
            </div>
            <div className='bg-white w-40 h-40 rounded-full blur-3xl absolute z-0 right-[10%] top-[20%]'></div>
            <div className='bg-white w-40 h-40 rounded-full blur-3xl absolute z-0 left-[10%] bottom-[20%]'></div>
        </div>
    )
}
